import makeStyles from '@material-ui/core/styles/makeStyles';

const styles = makeStyles(() => ({
  title: {
    flex: '1',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: '#192542',
    '& h1': {
      fontSize: '2rem',
      lineHeight: 1,
      fontWeight: 400,
      marginBottom: '0.5rem',
    },
    '& p': {
      fontSize: '1rem',
      lineHeight: '1.3125rem',
      color: '#818b9d',
    },
  },
}));

export default styles;
